import React from "react";

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`text-xs font-semibold uppercase tracking-[0.2em] text-teal-600 ${className}`}>{children}</span>
);

export const SectionHeading = ({ eyebrow, title, subtitle, center = false, light = false }) => (
  <div className={`${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} mb-12`}>
    {eyebrow && <Eyebrow className={light ? "text-teal-400" : ""}>{eyebrow}</Eyebrow>}
    <h2 className={`mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-snug ${light ? "text-white" : "text-slate-900"}`}>{title}</h2>
    {subtitle && <p className={`mt-4 text-base leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>{subtitle}</p>}
  </div>
);

export const PageHero = ({ eyebrow, title, subtitle, image, children }) => (
  <section className="relative bg-slate-900 overflow-hidden" data-testid="page-hero">
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 to-slate-900/90" />
      </>
    )}
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
      <div className="max-w-3xl tp-fade-up">
        {eyebrow && <Eyebrow className="text-teal-400">{eyebrow}</Eyebrow>}
        <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.05]">{title}</h1>
        {subtitle && <p className="mt-6 text-lg text-slate-300 leading-relaxed max-w-2xl">{subtitle}</p>}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </div>
  </section>
);

export const Section = ({ children, className = "", id }) => (
  <section id={id} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 ${className}`}>{children}</section>
);
